import React from 'react';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const spanStyle = {
  display: 'inline-block',
  cursor: 'pointer',
};

const SortingOptionToolTip = () => (
  <Tippy
    appendTo={ref => {
      return ref.parentNode;
    }}
    trigger="click"
    arrow="true"
    placement="right"
    content={
      <span className="param-details">
        <ul>
          <li>
            <strong>Recent</strong> – Sorts content by chronological order (descending)
          </li>
          <li>
            <strong>Shuffled</strong> – Sorts content by random order. The randomness is recomputed every 30 minutes.
          </li>
          <li>
            <strong>Photorank</strong> – Sorts content by its Photorank score. This score is predicted by the Olapic
            Machine Learning algorithm when the media object is registered in the system.
          </li>
          <li>
            <strong>Clickthrough Rate</strong> – Sorts content by its click-through rate. Requires event interactions
            via Olapic Widgets or Analytics API.
          </li>
          <li>
            <strong>Manual</strong> – Sorts content by the stream's manual sorting.
          </li>
        </ul>
      </span>
    }
  >
    <span style={spanStyle} onClick={e => e.preventDefault()}>
      <FontAwesomeIcon icon="question-circle" />
    </span>
  </Tippy>
);

export default SortingOptionToolTip;



// WEBPACK FOOTER //
// ./src/components/Sidebar/sortingOptionToolTip.js